import {React, useState} from 'react';
import { useParams, useNavigate } from "react-router-dom";
import styled from 'styled-components';

/** Composants */
import Logo from '../components/Logo.js'
import NavBar from '../components/NavBar.js'
import Footer from '../components/Footer.js'

/** Api */
import { apiElementById } from '../api.js';

const Page = styled.div`
position:relative;
min-height:100vh;
padding-bottom:300px;
`
const Titre = styled.h2`
margin:0 auto;
`

const Bouton = styled.button`
margin: 10px;
padding: 5px
`

const Champ = styled.input`
margin: 10px;
padding: 5px
`

const P1 = styled.div`
margin: 10px;
padding: 5px;
float:left;
width: 100%
`

const P2 = styled.div`
margin: 10px;
padding: 5px;
background-color: #acacac;
float:left;
`

const PageConsultation = () => {

    const dateValiditeJeton = new Date(localStorage.getItem('date_expired'))
    const connecte = localStorage.getItem('email') && (dateValiditeJeton > Date.now()) ?
            true : false

    const [id_element, setId_element] = useState(null)

    const {typeElement} = useParams()
    const navigate = useNavigate()

    const lienAjout = "/" + typeElement + "/add"
    const lienEdition = "/" +  typeElement + "/edit/"
    const lienSuppression = "/" +  typeElement + "/del/"
    const lienListe = "/search/" + typeElement + "/10/0"
    const lienRecents = "/" + typeElement + "/last/5"

    const capitalize = (chaine) => {
        return(chaine.charAt(0).toUpperCase() + chaine.slice(1))
    }

    const handlechangeId = (e) => {
        setId_element(e.target.value)
    }


    const handleClickSupprimer = () => {
        if (id_element) {
           navigate(lienSuppression + id_element)
        } else {
            return false
        }

    }

    const handleClickEdition = () => {
        if (id_element) {
            navigate(lienEdition + id_element)
        } else {
            return false
        }
    }

    const handleClickAjout = () => {
        navigate(lienAjout)
    }

    const handleClickRecents = () => {
        navigate(lienRecents)
    }

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Titre>Actions sur les {capitalize(typeElement)}s</Titre>
            <hr noshade="O" />
            <P1>
                Préciser un élément à l'aide de son identifiant : <Champ type="text" id="id_element" size="34" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" onChange={handlechangeId} defaultValue=""/>
            </P1>
            <P2>
                <Bouton onClick={() => navigate(lienListe)}>Lister</Bouton>
                <Bouton onClick={handleClickRecents}>Les dernières modifications</Bouton>
                { (typeElement !== 'notice') && connecte && <Bouton onClick={handleClickAjout}>Ajouter un nouvel élément</Bouton>}
                { (typeElement !== 'notice') && connecte && <Bouton onClick={handleClickSupprimer}>Modifier l'élement</Bouton>}
                { (typeElement !== 'notice') && connecte && <Bouton onClick={handleClickEdition}>Editer l'élement</Bouton>}
            </P2>
            <Footer/>
        </Page>
    )
}
export default PageConsultation
